<template>
  <v-container class="component_main px-6 py-0">
    <v-row>
      <v-col cols=12>
        <template v-if="[1, 46, 192].includes(grupoEconomico)">
        <h1>Relatório analítico de faturamento</h1>
        <p>Solicite o relatório analítico de faturamento.</p>
        </template>
      </v-col>
      <v-col cols=12>
       <RelatorioFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :updateFilter="(formData) => solicitaRelatorioConfirm(formData)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :validarForm="validarForm"
          :getOperadoras="(opts) => getOperadoras(opts)"
          :grupoEconomico="grupoEconomico"
          :parametros="cronogramaConfig"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import RelatorioFilter from "@/components/recebiveis/analitico_faturamento/Filter";

export default {
  components: {
    RelatorioFilter
  },
  data() {
    return {
      chartId: "1",
      filter:{},
      prestadores: [],
      validarForm: false,
      cronogramaConfig: {}
    };
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      userData: (state) => state.userData.userData,
    }),
  },
  beforeUpdate() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
  },
  beforeMount() {
    this.getParametrizacao()
  },
  mounted(){
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
    let opts = {
          grupo_economico: this.grupoEconomico,
          limitar: false,
          modulo_operadora: "recebiveis",
          prestador_ids: []
        }
    this.getOperadoras(opts)
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      getParametrizacao(){
        //let { operadora_ans_id, prestador_id } = this.cronogramadata
        let opts = {
        query: [
            {
            Modulo: "Portal",
            Acao: "getparametrizacoes",
            Payload: {
                grupo_economico: this.grupoEconomico
              },
            },
        ],
        noLoader: true,
        };
        this.$store.dispatch("request/doRequest", opts).then(resp => {
          this.parametros = resp.parametros
          if(this.cronogramaConfig != {} && this.cronogramaConfig != null)
            this.cronogramaConfig = resp.parametros
          return resp.parametros
          })
    },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    usaDate (date) {
        if (!date) return null
        const [year, day, month] = date.split('-')
        return `${year}-${day}-${month}`
    },
    solicitaRelatorioConfirm(filter) {
      const intervalo = 1000 * 60 * 60 * 24 * 365.25//1 ano
      if(this.filter.data_inicio == null &&
          this.filter.data_fim == null
      ){
              let paramModal = {
              type: "info",
              title: "Atenção:",
              message: "Selecione ao menos um período de tempo.",
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Cancelar", show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
      
      this.filter = filter
      let prestador = this.filter.prestador_id.length?this.filter.prestador_id.map( prest => this.prestadores.find(p=>p.id == prest).prest_nome).join(', ')+'.' : 'Todos'
      let operadora = this.filter.operadora_ans_id.length?this.filter.operadora_ans_id.map( oper => this.listOperadora.find(p=>p.id == oper).oper_nome).join(', ')+'.' : 'Todos'
      let dataInicial = this.formatDate(this.filter.data_inicio)
      let dataFinal = this.formatDate(this.filter.data_fim)

      if (dataInicial != null && (new Date(this.filter.data_fim) - new Date(this.filter.data_inicio)) / intervalo > 1
      ){
              let paramModal = {
              type: "info",
              title: "Atenção:",
              message: "O período máximo de 1 ano foi excedido.",
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Cancelar", show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
            return
      }

      let message = `
          Prestador(es): <strong>${prestador}</strong><br>
          Operadora(s): <strong>${operadora}</strong><br>`;

      if(this.filter.data_inicio || this.filter.data_fim){
        message +=  `Data entre <strong>${dataInicial}</strong> e <strong>${dataFinal}</strong><br>`
      }

      let paramModal = {
        type: "info",
        title: "Solicitar relatório de faturamento com o filtro:",
        message,
        callback: () => this.solicitaRelatorio(this.filter),
        btConfirm: { name: "Solicitar", show: true },
        btCancel: { name: "Cancelar", show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    solicitaRelatorio(formData) {
      let opts = {}
      if(formData == null){
        opts = Object.assign(this.pagination, { grupoEconomico: this.grupoEconomico, limitar: false }, this.filter)
        this.solicitaRelatorioConfirm(opts).then(()=>this.showList = true)
        return
      }
      formData.grupo_economico = this.grupoEconomico

      let acao ="GetAnaliticoFaturamento";
      let payload = formData

      var data = {
        query: 
        [{
          "Modulo": "recebiveis",
          "Acao": acao,
          "Payload": payload
        }]
      };
      
      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: response.warning? "warning":"success",
          title: "Atenção!",
          message: response.mensagem,
          callback: () => {},
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    validaForm(){
      this.validarForm = true
      this.$nextTick(()=>this.validarForm = false)
    }
  }
};
</script>
<style>
</style>